import React from "react";
import {
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Divider,
    Typography
} from "@mui/material";

export type ContextMenuAction = {
    icon?: React.ReactNode;
    label: string;
    onClick: () => void;
    color?: "primary" | "error" | "warning" | "success" | "info";
    dividerBefore?: boolean;
};

type FancyContextMenuProps = {
    actions: ContextMenuAction[];
    open: boolean;
    onClose: () => void;
    anchorPosition: { top: number; left: number } | null;
    title?: string;
};

const FancyContextMenu: React.FC<FancyContextMenuProps> = ({
                                                               actions,
                                                               open,
                                                               onClose,
                                                               anchorPosition,
                                                               title,
                                                           }) => {


    // Build flat array of MenuItem/Divider/etc.
    const items: React.ReactNode[] = [];

    if (title) {
        items.push(
            <Typography key="title" sx={{ px: 2, pt: 1, pb: 0.5, color: "#13315C", fontWeight: 600, fontSize: 15 }}>
                {title}
            </Typography>
        );
    }

    actions.forEach(({ icon, label, onClick, color, dividerBefore }, idx) => {
        if (dividerBefore) {
            items.push(<Divider key={`divider-${idx}`} sx={{ borderColor: "#e2e8f0" }} />);
        }
        items.push(
            <MenuItem
                key={`item-${idx}`}
                onClick={() => {
                    onClick();
                    onClose();
                }}
                sx={{
                    color: color ? `${color}.main` : "text.primary",
                    "&:hover": { bgcolor: "#f1f5f9" },
                    fontWeight: color === "error" ? 700 : undefined,
                    gap: 1.5,
                }}
            >
                {icon && <ListItemIcon sx={{ color: "inherit" }}>{icon}</ListItemIcon>}
                <ListItemText>{label}</ListItemText>
            </MenuItem>
        );
    });

    return (
        <Menu
            open={open}
            onClose={onClose}
            anchorReference="anchorPosition"
            anchorPosition={anchorPosition ?? undefined}
            disableEnforceFocus
            disableAutoFocusItem={false}
            PaperProps={{
                elevation: 8,
                sx: {
                    minWidth: 180,
                    borderRadius: 2,
                    mt: 1,
                    bgcolor: "#fff",
                    color: "text.primary",
                    border: "1px solid #e2e8f0",
                    boxShadow: "0 4px 20px rgba(15,23,42,0.15)",
                },
            }}
        >
            {items}
        </Menu>
    );
};

export default FancyContextMenu;
